export default "__VITE_ASSET__be302094__"